// 終わらぬ鬨（鶏）の鬨ずらし・短い鳴きを模型で（2026-11-03・模型の作り方を選ぶページの見本をそのまま移した）。
//   鳴く コッ・コッ・コッ（間 0.45秒）→ 鳴き止み 0.45秒後に1発目 → 爪 3発（間 0.45秒・毎発 跳んで前へ）。

import { BIRD_STAND } from '../body'
import { posePatch, type MockupMove, type Pose } from '../core'

const bp = posePatch(BIRD_STAND)
const CLUCK = bp({ head: [38, -142], beak: 1, nb: [24, -104], wN: [-34, -114], wF: [-30, -120], body: [-4, -88], bang: 18 })
const REST = bp({ head: [34, -132], beak: 0.15, wN: [-38, -104], wF: [-34, -110] })
const CUT = bp({ body: [0, -80], bang: 0, head: [42, -106], beak: 0, nb: [26, -96], wN: [-8, -150], wF: [-50, -142], tail: [-58, -114], hip: [2, -62], kN: [16, -52], fN: [30, -40], kF: [-8, -34], fF: [-6, 0] })
const wind = (rx: number, ry: number): Pose => bp({ body: [-2, -76], bang: 4, head: [36, -104], nb: [22, -92], wN: [-6, -146], wF: [-48, -136], tail: [-56, -112], hip: [0, -58], kN: [6, -62], fN: [20, -74], kF: [-6, -30], fF: [-6, 0], rx, ry })
const rakeA = (rx: number): Pose => bp({ body: [10, -82], bang: -14, head: [50, -104], nb: [34, -96], wN: [-14, -140], wF: [-50, -128], tail: [-48, -112], hip: [8, -66], kN: [34, -64], fN: [64, -56], kF: [-6, -34], fF: [-22, 0], rx })
const rakeB = (rx: number): Pose => bp({ body: [10, -80], bang: -10, head: [48, -100], nb: [32, -94], wN: [-30, -130], wF: [30, -122], tail: [-50, -110], hip: [8, -64], kF: [30, -38], fF: [58, -14], kN: [-6, -32], fN: [-20, 0], rx })
const END = bp({ rx: 168 })
const T0 = 300

export const ROOSTER_TOKI_MOCKUP: MockupMove = {
  id: 'rooster-toki-short', boss: '終わらぬ鬨（鶏）', label: '鬨ずらし・短い鳴き', body: 'bird',
  durMs: 3800, scale: 0.8, baseX: 340, heroAt: 270,
  keys: [
    [0, BIRD_STAND], [T0, BIRD_STAND], [T0 + 60, CLUCK], [T0 + 150, REST], [T0 + 450, REST], [T0 + 510, CLUCK], [T0 + 600, REST], [T0 + 900, REST],
    [T0 + 960, CLUCK], [T0 + 1050, REST], [T0 + 1170, CUT], [1690, CUT],
    [1745, wind(28, -12)], [1800, rakeA(56)], [1860, rakeA(56)], [2140, wind(84, -12)], [2250, rakeB(112)], [2310, rakeB(112)],
    [2590, wind(140, -12)], [2700, rakeA(168)], [2850, rakeA(168)], [3250, END], [3800, END],
  ].map(([at, pose]) => ({ at: at as number, pose: pose as Pose })),
  phases: [
    { from: 0, to: T0, label: '構え', kind: 'rest' },
    { from: T0, to: T0 + 1050, label: '鳴く：コッ・コッ・コッ（間 0.45秒）', kind: 'tell' },
    { from: T0 + 1050, to: 1760, label: '鳴き止み → 0.45秒後に1発目', kind: 'tell' },
    { from: 1760, to: 2740, label: '爪 タ・タ・タ（間 0.45秒・毎発 跳んで前へ）', kind: 'hit' },
    { from: 2740, to: 3800, label: '戻り', kind: 'rest' },
  ],
  hits: [1770, 2220, 2670], activeMs: 65, box: [30, 112, -92, -4], paths: ['fN', 'fF'],
  cues: [0, 1, 2].map(i => ({ at: T0 + i * 450, ms: 150 })), fadeOutMs: 400,
}
